import { useNavigate } from 'react-router'
import Logo from '../components/Logo'
import { useT } from '../i18n/useT'

export default function Login() {
  const t = useT()
  const navigate = useNavigate()

  const goToSignup = () => {
    navigate('/')
    requestAnimationFrame(() => {
      setTimeout(() => {
        document
          .getElementById('get-started')
          ?.scrollIntoView({ behavior: 'smooth' })
      }, 50)
    })
  }

  return (
    <section className="bg-gradient-to-b from-brand-50 via-white to-white">
      <div className="mx-auto max-w-7xl px-8 py-20 grid place-items-center">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl border border-slate-100 shadow-[0_24px_60px_-24px_rgb(15_23_42/0.25)] p-9">
            <div className="flex justify-center mb-7">
              <Logo className="h-8 w-auto" />
            </div>
            <h1 className="text-2xl font-extrabold text-center mb-2">
              {t.login.title}
            </h1>
            <p className="text-sm text-ink-mute text-center mb-8">
              {t.login.sub}
            </p>

            <form className="space-y-3.5" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                required
                placeholder={t.login.email}
                className="w-full h-11 rounded border border-slate-200 px-3.5 text-[15px] placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500/40 focus:border-brand-500"
              />
              <input
                type="password"
                required
                placeholder={t.login.password}
                className="w-full h-11 rounded border border-slate-200 px-3.5 text-[15px] placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500/40 focus:border-brand-500"
              />
              <div className="flex items-center justify-between pt-1 pb-2">
                <label className="flex items-center gap-2 text-sm text-ink-soft cursor-pointer select-none">
                  <input
                    type="checkbox"
                    className="w-4 h-4 rounded border-slate-300 accent-brand-600"
                  />
                  {t.login.remember}
                </label>
                <a
                  href="#"
                  className="text-sm font-semibold text-brand-700 hover:text-brand-800"
                >
                  {t.login.forgot}
                </a>
              </div>
              <button
                type="submit"
                className="w-full h-11 rounded bg-brand-600 hover:bg-brand-700 transition-colors text-white font-semibold text-[15px]"
              >
                {t.login.submit}
              </button>
            </form>
          </div>

          <p className="text-center text-[15px] text-ink-mute mt-6">
            {t.login.noAccount}{' '}
            <button
              onClick={goToSignup}
              className="font-semibold text-brand-700 hover:text-brand-800 cursor-pointer"
            >
              {t.login.start}
            </button>
          </p>
        </div>
      </div>
    </section>
  )
}
